export default {
  NOTIFICATION_DEFAULT: 'NOTIFICATION_DEFAULT',
  NOTIFICATION_CLIMATE_COMPENSATION: 'NOTIFICATION_CLIMATE_COMPENSATION',
  NOTIFICATION_PRICE_DROP_PROTECTION: 'NOTIFICATION_PRICE_DROP_PROTECTION',
  SELF_TRANSFER_GUARANTEE: 'SELF_TRANSFER_GUARANTEE'
};